[
  {
    "id": "SWW-E8-L305-001",
    "module": "SpellingWW",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "question": "Hij ... al uren op antwoord. (wachten)",
    "options": ["wacht", "wachtte", "heeft gewacht", "gewacht"],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_kofschip",
    "familyId": "SWW-VTDT-DUUR-WACHTEN",
    "conceptId": "vtdt_duur_context_wachten",
    "variantIndex": 1,
    "explanation": "Door 'al uren' klinkt het alsof het eerder begon en nog steeds geldt. Dan gebruik je voltooide tijd: hij heeft gewacht.\nHet voltooid deelwoord van 'wachten' is 'gewacht' (stam eindigt op t, dus hoort bij 't kofschip).",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. Bij 'al uren' past voltooide tijd beter.",
      "2": "Dit is verleden tijd. Dat klinkt alsof het echt afgesloten is, terwijl 'al uren' juist een duur aangeeft.",
      "3": "Dit is alleen het voltooid deelwoord. In de zin heb je ook 'heeft' nodig: heeft gewacht."
    }
  },
  {
    "id": "SWW-E8-L305-002",
    "module": "SpellingWW",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "question": "Zij ... dat het plan zou mislukken. (vermoeden)",
    "options": ["vermoedde", "vermoed", "vermoedt", "heeft vermoed"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_geen_kofschip",
    "familyId": "SWW-VT-KEUZE-VERMOEDEN",
    "conceptId": "vt_zwak_geen_kofschip_vermoeden",
    "variantIndex": 1,
    "explanation": "De zin gaat over iets dat al speelde (verleden). Dan kies je verleden tijd: vermoedde.\nBij zwakke werkwoorden gebruik je 'de' als de stam niet eindigt op een 't kofschip-letter.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. De zin gaat duidelijk over vroeger.",
      "2": "Dit is ook tegenwoordige tijd (hij/zij/het). Past niet bij de context.",
      "3": "Dit is voltooide tijd, maar er staat geen passend hulpwerkwoord in de zin (zoals 'had/heeft')."
    }
  },
  {
    "id": "SWW-E8-L305-003",
    "module": "SpellingWW",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "question": "Het team ... door de coach. (leiden)",
    "options": ["wordt geleid", "word geleid", "werd geleid", "is geleid"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_dt",
    "familyId": "SWW-TT-DT-WORDEN-WORDT",
    "conceptId": "tt_dt_wordt",
    "variantIndex": 1,
    "explanation": "Dit is een lijdende vorm in de tegenwoordige tijd: wordt + voltooid deelwoord.\nDe persoonsvorm is 'wordt' (met t) bij hij/zij/het. Daarom: wordt geleid.",
    "distractorExplanations": {
      "1": "Hier mist de t in 'wordt'. Bij 'het team' hoort 'wordt'.",
      "2": "Dit is verleden tijd. In de zin gaat het om wat er nu gebeurt.",
      "3": "Dit is geen goede combinatie voor deze betekenis. In de lijdende vorm gebruik je 'wordt geleid'."
    }
  },
  {
    "id": "SWW-E8-L305-004",
    "module": "SpellingWW",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "question": "De ... documenten liggen klaar. (kopiëren)",
    "options": ["gekopieerde", "gekopiëerde", "gekopieerd", "kopieerde"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bn_vd",
    "familyId": "SWW-BNVD-KOPIEREN-MEERVOUD",
    "conceptId": "bnvd_meervoud_kopieren",
    "variantIndex": 1,
    "explanation": "Je beschrijft de documenten. Dan gebruik je het bijvoeglijk gebruikte voltooid deelwoord.\nVoltooid deelwoord: gekopieerd. Bij meervoud komt er -e achter: gekopieerde documenten.",
    "distractorExplanations": {
      "1": "Hier staat een trema die je in deze vorm niet nodig hebt. De juiste vorm is gekopieerde.",
      "2": "Dit is het voltooid deelwoord zonder -e. Bij 'de documenten' hoort de bijvoeglijke vorm met -e.",
      "3": "Dit is verleden tijd. De zin vraagt om een beschrijving van de documenten."
    }
  }
]
